import { SimpleRepairsUpdatesCommentsPostRequest } from './post'

export class SimpleRepairsUpdatesCommentsPutRequest extends SimpleRepairsUpdatesCommentsPostRequest {
  commentId!: string
  version!: number
}
